module.exports = __webpack_public_path__ + "img/clock.5b47531d.svg";